import { Merchant } from './merchant';
import { Customer } from './customer';
import { Cart } from './cart';
import { Callbacks } from './callbacks';

export class Checkout {
  merchant: Merchant;
  customer: Customer;
  cart: Cart;
  callbacks: Callbacks;
}
